import React, { useEffect, useRef, useState } from "react";
import NotificationIcon from "./components/notiificationicon"
import NotificationBar from "./components/notificationPopup";
import { startNotificationWorker, stopNotificationWorker } from "./worker/workerListener";
import { useDispatch } from "react-redux";
import NotificationAlert from "./NotificationAlert";

/**
 * @author Aston Kingsley
 * @returns 
 */
const Notifications=()=>{
    const [anchorEl,setAnchorEl]=useState(null);
    const dispatch=useDispatch();
    const workerStarted = useRef(false);
    /**
     * in below useEffect we will start the web worker
     * it will run in a separated thread
     *It will call the count api
     */
    useEffect(() => {
        if (!workerStarted.current) {
            startNotificationWorker(dispatch);
            workerStarted.current = true;
        }
        return () => {
            stopNotificationWorker(dispatch);
            workerStarted.current = false;
        };
    }, [dispatch, workerStarted]);

    /**
     * function to close the notification popup
     */
    const handleClose=()=>{
      setAnchorEl(null);
    }

    return (
        <>
        <NotificationIcon setAnchorEl={setAnchorEl}/>
        <NotificationBar anchorEl={anchorEl} handleClose={()=>handleClose()} setAnchorEl={setAnchorEl}/>
        <NotificationAlert setAnchorEl={setAnchorEl}/>
        </>
    )
}

export default Notifications;